module.exports = __webpack_public_path__ + "img/dialog-bg.7f02bfa9.png";